import _ from 'lodash';
import { attrSelector } from 'client/utils';

/**
 * Generate object with state data attributes
 * to spread onto DOM element (BuildingBlock root node)
 */
export class StateDOMAttrubutesManager {
	constructor(props) {
		// @ts-expect-error ts-migrate FIXME
		this.states = props;
	}

	get attributes() {
		const attrubutes = _.reduce(
			// @ts-expect-error ts-migrate FIXME
			this.states,
			(memo, value, key) => {
				if (value) {
					_.set(memo, attrSelector(key), '');
				}
				return memo;
			},
			{}
		);
		return attrubutes;
	}
}
